import { styled } from "@mui/material"
import { ExtendedElement } from "./extended"

// TODO: remove any
export const CustomRowElement = styled(ExtendedElement)(({ theme }) => ({
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    display: "block",
    justifyContent: "left",
})) as typeof ExtendedElement
